module.exports = __webpack_public_path__ + "img/image-3.b6c3d458.jpg";